/* eslint-disable react/jsx-indent */
import React from 'react';
import PropTypes from 'prop-types';
import { C, T, noHTML, Masks } from 'shared/helpers';

import Styles from './TopTable.module.scss';

import Select from 'components/Template/Select/Select';
import Radio from 'components/Template/Radio/Radio';
import NumberFormat from 'react-number-format';
import { availableAttributes } from 'shared/business';
import moment from 'moment';

function renderResposta(respostas, perguntaid, atributosPergunta, type, defaultValue = '') {
  const resposta =
    T(
      respostas.find(
        (resposta) => String(resposta.pergunta_id) === String(perguntaid),
      ),
    ).resposta || defaultValue;

  if (type === 'date') {
    return moment(resposta || new Date()).format('L');
  }

  const attributos = atributosPergunta.class.split(' ');
  const isMoeda =
    attributos.includes(availableAttributes.moedaPtBr) ||
    attributos.includes(availableAttributes.moedaPtBrHectare);

  const isNumeric = !Number.isNaN(Number(resposta));

  if (
    isMoeda ||
    (atributosPergunta.inputGroup && atributosPergunta.inputGroup === 'ha')
  ) {
    return isMoeda
      ? Masks.currency(resposta || 0, {
        suffix: attributos.includes(availableAttributes.moedaPtBrHectare)
          ? ' /ha'
          : '',
      })
      : isNumeric
        ? Masks.number(resposta, { suffix: ' /ha', ed: 2 })
        : `${resposta} /ha`;
  }
  if (type === 'number') {
    return Masks.number(resposta);
  }
  return typeof resposta === 'string' ? resposta : String(resposta);
}

export default function TopTable({
  edit,
  cultura,
  perguntas,
  respostas,
  estados,
  form,
  setForm,
  productionUnit,
}) {
  const { TopTable, Row, Block, First, Edit, Unit, Last } = Styles;

  let divCount = 0;
  const k = () => `toptable${++divCount}`;

  return (
    <div className={TopTable}>
      <header>
        <div style={{ width: '70%' }}>CULTURA</div>
        <div style={{ width: '30%' }}>{cultura}</div>
      </header>
      <main>
        {perguntas.map(({ pergunta, attributes, type, id, options }) => (
          <div key={k()} className={Row}>
            <div className={C(Block, First, [type === 'radio' && edit, Last])}>
              {noHTML(pergunta, productionUnit)}
            </div>
            <div
              className={C(
                Block,
                [edit, Edit],
                [type === 'radio' && edit, Last],
              )}
            >
              {form &&
                (!edit ? (
                  type === 'radio' && form[id] ? (
                    typeof form[id] === 'string' ? (
                      JSON.parse(form[id])[0] ? (
                        'Simulação'
                      ) : (
                          'Resultado Final'
                        )
                    ) : form[id][0] ? (
                      'Simulação'
                    ) : (
                          'Resultado Final'
                        )
                  ) : (
                      renderResposta(respostas, id, attributes, type, form[id])
                    )
                ) : (
                    <>
                      {type === 'select' ? <Select
                        boxStyle={{ fontSize: '1em' }}
                        valueRef={form[id]}
                        options={options.map(({ label, value, resposta }) =>
                          value && label ? { label, value } : resposta || '',
                        )}
                        setValueRef={setForm}
                        stateKey={id}
                        disabled={false}
                        style={{ minWidth: '105%', boxShadow: 'none' }}
                      /> : type === 'estados' ? (
                        <Select
                          id='estados_selector'
                          boxStyle={{ fontSize: '1em' }}
                          valueRef={form[id]}
                          options={estados.map((estado) => estado.nome)}
                          setValueRef={setForm}
                          stateKey={String(
                            T(perguntas.find((x) => x.code === 'estado')).id,
                          )}
                          disabled={true}
                          style={{ minWidth: '105%', boxShadow: 'none' }}
                        />
                      ) : type === 'radio' ? (
                        <div className={Last}>
                          {options.map((option) => (
                            <Radio
                              state={
                                typeof form[id] === 'string'
                                  ? JSON.parse(form[id])
                                  : form[id]
                              }
                              setter={(S) => {
                                setForm((form) => ({
                                  ...form,
                                  [id]: { ...S },
                                }));
                              }}
                              choiceId={option.value}
                              label={option.label}
                            />
                          ))}
                        </div>
                      ) : attributes.class.split(' ').includes('moedaPtBr') ||
                        attributes.class
                          .split(' ')
                          .includes('moedaPtBrHectare') ? (
                                <NumberFormat
                                  allowEmptyFormatting
                                  prefix={'R$ '}
                                  onValueChange={({ floatValue }) =>
                                    setForm((form) => ({ ...form, [id]: floatValue }))
                                  }
                                  {...(attributes || {})}
                                  value={form[id] ? Number(form[id]) : ''}
                                  thousandSeparator={'.'}
                                  decimalSeparator={','}
                                />
                              ) : type === 'number' ? <NumberFormat
                                value={form[id] ? Number(form[id]) : ''}
                                thousandSeparator={'.'}
                                decimalSeparator={','}
                                {...(attributes || {})}
                                onValueChange={({ floatValue }) =>
                                  setForm((form) => ({ ...form, [id]: floatValue || 0 }))
                                }
                              /> : (
                                  <input
                                    disabled={attributes.readonly ? true : undefined}
                                    type={type}
                                    onChange={({ target: { value } }) =>
                                      setForm((form) => ({ ...form, [id]: value }))
                                    }
                                    value={form[id]}
                                  />
                                )}
                      <div className={Unit}>
                        {attributes.class.split(' ').includes('moedaPtBrHectare')
                          ? ' /ha'
                          : (attributes.inputGroup &&
                            !attributes.inputGroup.includes('{{') &&
                            `/${attributes.inputGroup}`) ||
                          (attributes.inputGroup &&
                            attributes.inputGroup.includes('{{') &&
                            attributes.inputGroup
                              .replace('{{', '')
                              .replace('}}', '') === 'unidadeProducao' &&
                            productionUnit)}
                      </div>
                    </>
                  ))}
            </div>
          </div>
        ))}
      </main>
    </div>
  );
}

TopTable.defaultProps = {
  edit: false,
  productionUnit: 'kg',
};

TopTable.propTypes = {
  edit: PropTypes.bool,
  cultura: PropTypes.string.isRequired,
  perguntas: PropTypes.array.isRequired,
  respostas: PropTypes.array.isRequired,
  estados: PropTypes.array.isRequired,
  form: PropTypes.object.isRequired,
  setForm: PropTypes.func.isRequired,
  productionUnit: PropTypes.string,
};
